import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../../../../form/TextField';
import { handleBlurEvent } from '../../utilities/utilities';

export const FirstNameInputComponent = React.forwardRef(({
  value,
  onChange,
  error,
  errorMessage,
}, ref) => (
  <TextField
    id="in-page-lead-form-first-name-input"
    label='First name'
    ref={ref}
    name='firstName'
    value={value}
    error={error}
    errorMessage={errorMessage}
    onChange={onChange}
    onBlur={handleBlurEvent}
    required={true}
    customTheme={'leads'}
    maxLength={100} />
));

FirstNameInputComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default FirstNameInputComponent;
